import { Component, inject } from '@angular/core';
import { AdminBoilerplateComponent } from "../../../core/admin-boilerplate/feature/admin-boilerplate.component";
import { Store } from '@ngrx/store';
import { selectAdminPrivilegedUsers, selectAdminUsers } from '../../../data-services/stores/selectors/admin.selectors';
import { adminActions } from '../../../data-services/stores/actions/admin.actions';
import { CommonModule } from '@angular/common';
import { UserBasic } from '../../../data-services/models/account/user-basic.model';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEye, faPeopleRoof, faSitemap, faStar } from '@fortawesome/free-solid-svg-icons';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-users',
  imports: [AdminBoilerplateComponent,CommonModule,FontAwesomeModule,RouterModule],
  templateUrl: '../ui/users.component.html',
  styleUrl: '../ui/users.component.css'
})
export class AdminUsersComponent {
  private readonly _store = inject(Store);
  private readonly _iconLib = inject(FaIconLibrary);
  users$ = this._store.select(selectAdminPrivilegedUsers);

  constructor() {
    this._store.dispatch(adminActions.getUsers());
    this._iconLib.addIcons(faEye,faStar,faSitemap,faPeopleRoof)
  }

  checkPermission(user: UserBasic, permissions: string[]): boolean {
    return user.permissions?.some(x => permissions.includes(x)) ?? false
  }
}

